import { render, staticRenderFns } from "./ManagementFooter.vue?vue&type=template&id=710c0064"
import script from "./ManagementFooter.vue?vue&type=script&lang=ts"
export * from "./ManagementFooter.vue?vue&type=script&lang=ts"
import style0 from "./ManagementFooter.vue?vue&type=style&index=0&id=710c0064&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports